import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import TributoService from 'business/cadastro/fiscal/tributo/tributoService'
import FormList from 'base/FormList'
import { InputSwitch } from 'primereact/inputswitch'

export default function TributoList() {

    const [service] = useState(() => new TributoService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_tri',
        dsName: 'descricao_tri',
        mainField: { name: 'descricao_tri', label: 'Descrição' },
        advFields: [
            { name: 'codigo_tri', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_tri', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'sigla_tri', label: 'Sigla', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true} tableStyle={{ minWidth: '1200px' }}>
            <Column field="codigo_tri" sortable header="Código"></Column>
            <Column field="descricao_tri" sortable header="Descrição"></Column>
            <Column field="sigla_tri" sortable header="Sigla"></Column>
        </FormList >
    )
}

function boolTemplate(field) {
    return (rowData) => <InputSwitch checked={rowData[field] === 1 || rowData[field] === true} disabled />
}
